import { api, LightningElement, ShadowRootTheGoodPart } from "lwc";
import { Config } from "tds/header";
import { Completion, RecentSection, SearchEvent } from "../search/types";

const getHiddenInput = (template: ShadowRootTheGoodPart) =>
  template.querySelector('input[name="keywords"]') as HTMLInputElement;

const getForm = (template: ShadowRootTheGoodPart) =>
  template.querySelector("form")! as HTMLFormElement;

export default class HeaderSearch extends LightningElement {
  @api config: Config["search"] = undefined;
  @api completions: Completion[] | null = [];
  @api recents: RecentSection[] | null = null;
  @api defaultValue: string | null = null;

  private setup = false;

  renderedCallback() {
    if (this.setup) return;

    if (this.defaultValue) {
      this.setHiddenInputValue(this.defaultValue);
    }

    this.setup = true;
  }

  private setHiddenInputValue(value?: string) {
    const input = getHiddenInput(this.template);
    input.value = value || "";
  }

  private handleSearchChange(e: CustomEvent) {
    const { value } = e.detail;
    this.setHiddenInputValue(value);
  }

  private handleSearch(e: CustomEvent<SearchEvent>) {
    const { value, type } = e.detail;
    const form = getForm(this.template);

    switch (type) {
      case "completion": {
        this.setHiddenInputValue(value.value);
        form.submit();
        break;
      }
      case "recent": {
        window.location.href = value.path;
        break;
      }
      default:
        this.setHiddenInputValue(value);
        form.submit();
        break;
    }
  }
}
